module.exports = __webpack_public_path__ + "img/getread-no-wifi.30860f31.png";